import { create } from "zustand";
import { persist } from "zustand/middleware";

import i18n from "@/config/i18n";

interface LanguageState {
	currentLanguage: "en" | "nb-NO";
	isLoading: boolean;
	setLanguage: (newValue: "en" | "nb-NO") => Promise<void>;
	_hasHydrated: boolean;
	setHasHydrated: (state: boolean) => void;
}

const useLanguage = create<LanguageState>()(
	persist(
		(set) => ({
			currentLanguage: "en",
			isLoading: true,
			setLanguage: async (newValue) => {
				// Set isLoading to true while changing language
				set({ isLoading: true });

				try {
					await i18n.changeLanguage(newValue); // Wait for language change
					set({ currentLanguage: newValue });
				} finally {
					// Ensure isLoading is set to false after the operation
					set({ isLoading: false });
				}
			},
			_hasHydrated: false,
			setHasHydrated: (state) => {
				set({
					_hasHydrated: state,
				});
			},
		}),
		{
			name: "language-store",
			onRehydrateStorage: () => (state) => {
				if (state?.currentLanguage) {
					state.isLoading = true;
					i18n
						.changeLanguage(state.currentLanguage)
						.then(() => {
							state.isLoading = false;
							state.setHasHydrated(true);
						})
						.catch((error) => {
							console.error(
								"Failed to change language during rehydration",
								error
							);
							state.isLoading = false;
						});
				}
			},
		}
	)
);

export default useLanguage;
